
import UsdCoin from "../../../assets/filled/UsdCoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UsdCoinIcon({ className, dataTestid = "UsdCoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <UsdCoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
